import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Kommune } from '../../../../api/models';
import { KommunerService } from '../../../../api/services';
import { AutocompleteItem } from '../../autocomplete/autocomplete-item';
import { AutocompleteItemsService } from '../../autocomplete/autocomplete-items.service';

@Injectable({
  providedIn: 'root',
})
export class EjendomsoegningService implements AutocompleteItemsService {
  private kommuner: Kommune[];
  private items$: Observable<Kommune[]>;
  constructor(private kommunerService: KommunerService) {}

  getAutocompleteItems(term: string): Observable<AutocompleteItem[]> {
    if (!this.kommuner) {
      this.items$ = this.kommunerService.getAll().pipe(take(1));
    } else {
      this.items$ = of(this.kommuner);
    }

    return this.items$.pipe(
      map(kommuner => {
        this.kommuner = kommuner;
        return this.kommuner
          .filter(f => f.navn.toLocaleLowerCase().startsWith(term.toLocaleLowerCase(), 0))
          .map(i => ({
            label: i.navn,
            value: i,
          }));
      })
    );
  }
}
